"use strict";
/**
 * Created by rouven on 23.02.17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Columns_1 = __importDefault(require("../Columns"));
var Row_1 = __importDefault(require("../Row"));
var Header_1 = __importDefault(require("../Header"));
var FullRow_1 = __importDefault(require("../FullRow"));
// @ts-ignore
var react_loading_1 = __importDefault(require("@wikom/react-loading"));
var Pagination_1 = __importDefault(require("../Pagination"));
var GridComponent = /** @class */ (function (_super) {
    __extends(GridComponent, _super);
    function GridComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.createColumns(props.children);
        _this._rows = _this.buildRows(props);
        return _this;
    }
    GridComponent.prototype.componentDidMount = function () {
        this.props.initializeGrid(this.props.grid);
        this.props.changeData(this.props.grid, this.props.data);
    };
    GridComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.grid !== nextProps.grid) {
            this.props.destroyGrid(this.props.grid);
            this.props.initializeGrid(nextProps.grid);
            this.createColumns(nextProps.children);
        }
        if (JSON.stringify(this.props.isLoading) !== JSON.stringify(nextProps.isLoading)
            || JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
            this.props.changeData(nextProps.grid, nextProps.data);
            this._rows = this.buildRows(nextProps);
        }
        else if (JSON.stringify(this.props.selection) !== JSON.stringify(nextProps.selection)) {
            this._rows = this.buildRows(nextProps);
        }
    };
    GridComponent.prototype.componentWillUnmount = function () {
        this.props.destroyGrid(this.props.grid);
    };
    GridComponent.prototype.createColumns = function (children) {
        var columns = [];
        react_1["default"].Children.forEach(children, function (child) {
            // @ts-ignore
            if (react_1["default"].isValidElement(child) && child.type === Columns_1["default"]) {
                react_1["default"].Children.forEach(child.props.children, function (col) {
                    if (react_1["default"].isValidElement(col)) {
                        columns.push(col);
                    }
                });
            }
        });
        this._columns = columns;
    };
    GridComponent.prototype.buildRows = function (_a) {
        var _this = this;
        var grid = _a.grid, isLoading = _a.isLoading, data = _a.data, rowIdAccessor = _a.rowIdAccessor, trClassNameAccessor = _a.trClassNameAccessor, props = __rest(_a, ["grid", "isLoading", "data", "rowIdAccessor", "trClassNameAccessor"]);
        return isLoading
            ? react_1["default"].createElement(FullRow_1["default"], { colSpan: this._columns.length },
                react_1["default"].createElement(react_loading_1["default"], null))
            : (data && data.length > 0
                ? data.map(function (rowData, i) {
                    return (react_1["default"].createElement(Row_1["default"], __assign({ rowData: rowData, key: i, rowId: i, grid: grid, trId: rowIdAccessor ? rowIdAccessor(rowData, i) : undefined, trClassName: trClassNameAccessor ? trClassNameAccessor(rowData, i) : undefined }, props), _this._columns));
                })
                : react_1["default"].createElement(FullRow_1["default"], { colSpan: this._columns.length }, "Keine Ergebnisse vorhanden"));
    };
    GridComponent.prototype.render = function () {
        var _a = this.props, grid = _a.grid, pagination = _a.pagination, handleSort = _a.handleSort, activeSort = _a.activeSort, actions = _a.actions, pageSizes = _a.pageSizes, paginationAfterGrid = _a.paginationAfterGrid, paginationCountFormat = _a.paginationCountFormat, boxHeader = _a.boxHeader;
        var hasPagination = pagination && grid;
        // @ts-ignore
        var header = react_1["default"].createElement(Header_1["default"], { grid: grid, columns: this._columns, handleSort: handleSort, activeSort: activeSort });
        var tableClassName = this.props.tableClassName || "table table-striped table-hover table-bordered table-condensed";
        var boxClassName = this.props.boxClassName || "box";
        return (react_1["default"].createElement("div", { className: "grid-view" },
            react_1["default"].createElement("div", { className: boxClassName },
                boxHeader || null,
                react_1["default"].createElement("div", { className: "box-body" },
                    actions,
                    hasPagination && paginationAfterGrid === false
                        ? (react_1["default"].createElement(Pagination_1["default"], __assign({ grid: grid, pageSizes: pageSizes, 
                            // @ts-ignore
                            paginationCountFormat: paginationCountFormat }, pagination)))
                        : null,
                    react_1["default"].createElement("div", { className: "row" },
                        react_1["default"].createElement("div", { className: "col-md-12" },
                            react_1["default"].createElement("div", { className: "table-grid" },
                                react_1["default"].createElement("div", { className: "table-responsive" },
                                    react_1["default"].createElement("table", { className: tableClassName },
                                        react_1["default"].createElement("thead", null, header),
                                        react_1["default"].createElement("tbody", null, this._rows)))))),
                    hasPagination && paginationAfterGrid === true
                        ? (react_1["default"].createElement(Pagination_1["default"], __assign({ grid: grid, pageSizes: pageSizes, 
                            // @ts-ignore
                            paginationCountFormat: paginationCountFormat }, pagination)))
                        : null))));
    };
    return GridComponent;
}(react_1["default"].Component));
exports["default"] = GridComponent;
